import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetAllUsers = ()  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/usuarios`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAllUsersMutation: mutation.mutate,
    };
}